import React from 'react';
import { Box, Icon, SimpleGrid, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import Container from '../ui/Container';
import SectionHeader from '../ui/SectionHeader';
import { SECTORS } from '../../data/sectors';

export default function SectorsSection() {
  return (
    <Box as="section" py={{ base: 14, md: 20 }}>
      <Container>
        <SectionHeader title="Sectores que atendemos" />
        <SimpleGrid columns={{ base: 2, sm: 3, lg: 5 }} spacing={4}>
          {SECTORS.map(sector => (
            <Box key={sector.id} as={RouterLink} to="/projects"
              display="flex" flexDirection="column" alignItems="center"
              justifyContent="center" gap={3} py={8} px={4} minH="140px"
              bg="surface.default" borderRadius="lg" border="1px solid"
              borderColor="border.default" transitionDuration="200ms"
              _hover={{ borderColor: 'accent.default', boxShadow: 'sm' }}
              _focusVisible={{ boxShadow: 'outline' }}>
              <Icon as={sector.icon} boxSize={8} color="accent.default" aria-hidden="true" />
              <Text fontSize="sm" fontWeight={600}>{sector.label}</Text>
            </Box>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
